import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

function RecurringTaskBadge({ task, className = '' }) {
  if (!task?.isRecurringTask) return null;

  const frequencyName = task?.RecurringTaskFrequency?.name;
  const label = frequencyName ? `Recurring: ${frequencyName}` : 'Recurring task';

  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 300 }}
      overlay={<Tooltip>{label}</Tooltip>}
    >
      <span className={`badge fw-semibold ${className}`} style={{ backgroundColor: 'var(--bs-info-bg-subtle)', color: 'var(--bs-info-text-emphasis)' }}>
        <i className="fa fa-repeat me-1" aria-hidden="true" />
        {frequencyName || 'Recurring'}
      </span>
    </OverlayTrigger>
  );
}

export default RecurringTaskBadge;
